import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EnvironmentManager from 'Utils/environmentManager';
import {
  setHRBetslipMultiplier,
  setHRBetslipCouponCount
} from 'Store/actions/horseRacing/betSlipActions';
import { PROGRAM_TYPES } from 'Store/constants/horseRacing';

export const useHRBetslipSystem = () => {
  const programType = useSelector(state => state.horseRacing.allHippodromes.programType);
  const isFixedOdd = programType === PROGRAM_TYPES.FIXED;
  const betSlip = useSelector(state => state.horseRacing.betSlip);
  const { combinedHorses, footerData } = betSlip;
  const { system, couponCount } = footerData;
  const [systemSelected, setSystemSelected] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isFixedOdd) return;
    const horseCount = combinedHorses?.length || 0;
    if (horseCount === 0) {
      setSystemSelected(false);
      return;
    }

    if (system?.length === 1 && system[0] === horseCount) {
      setSystemSelected(false);
      return;
    }

    if (system?.length > 0) {
      setSystemSelected(true);
    } else {
      setSystemSelected(false);
    }
  }, [system, combinedHorses, isFixedOdd]);

  useEffect(() => {
    if (!isFixedOdd) return;
    if (!systemSelected) return;
    const minMultiplier = Number(
      EnvironmentManager.getMessageText({ key: 'v1.betslip_fixodd.minimum_multiplier' }) || 20
    );
    const multiplier = systemSelected ? 1 : minMultiplier;
    const count = systemSelected ? 1 : couponCount;
    dispatch(setHRBetslipMultiplier(multiplier));
    dispatch(setHRBetslipCouponCount(count));
  }, [systemSelected, dispatch, setHRBetslipMultiplier, isFixedOdd]);

  return { systemSelected };
};
